// extracted by mini-css-extract-plugin
export default {"root":"CommentForm_root__6c8vE","form":"CommentForm_form__DFW0p","after":"CommentForm_after__TLFq0"};